/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaReach,
    MediaReachFromJSON,
    MediaReachFromJSONTyped,
    MediaReachToJSON,
} from './MediaReach';

/**
 * request of POST /prtimes_media_lists/media_outlets
 * @export
 * @interface GetPrtimesMediaListsMediaOutletsRequest
 */
export interface GetPrtimesMediaListsMediaOutletsRequest {
    /**
     * メディアリストIDのリスト
     * @type {Array<number>}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    mediaListIds: Array<number>;
    /**
     * メディア種類IDのリスト
     * @type {Array<number>}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    mediaTypeIds: Array<number>;
    /**
     * 発行部数/PVのリスト
     * @type {Array<MediaReach>}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    reaches: Array<MediaReach>;
    /**
     * 取得ページ番号(1から)。
     * @type {number}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    page?: number;
    /**
     * ページごとのアイテム数（デフォルトは100）
     * @type {number}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    perPage?: number;
    /**
     * ソート対象のフィールド名。デフォルトはメディアをメディアリストに追加した順(added_at)の降順。複数選択不可。
     * @type {string}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    sortField?: GetPrtimesMediaListsMediaOutletsRequestSortFieldEnum;
    /**
     * ソート順。複数選択不可。
     * @type {string}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    sortOrder?: GetPrtimesMediaListsMediaOutletsRequestSortOrderEnum;
    /**
     * メディアリストに含まれる全てのメディアを取得するかどうか指定できる（デフォルトはfalse）
     * @type {boolean}
     * @memberof GetPrtimesMediaListsMediaOutletsRequest
     */
    dangerouslyFetchAllMediaOutlets?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum GetPrtimesMediaListsMediaOutletsRequestSortFieldEnum {
    AddedAt = 'added_at'
}/**
* @export
* @enum {string}
*/
export enum GetPrtimesMediaListsMediaOutletsRequestSortOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}

export function GetPrtimesMediaListsMediaOutletsRequestFromJSON(json: any): GetPrtimesMediaListsMediaOutletsRequest {
    return GetPrtimesMediaListsMediaOutletsRequestFromJSONTyped(json, false);
}

export function GetPrtimesMediaListsMediaOutletsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrtimesMediaListsMediaOutletsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListIds': json['media_list_ids'],
        'mediaTypeIds': json['media_type_ids'],
        'reaches': ((json['reaches'] as Array<any>).map(MediaReachFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'perPage': !exists(json, 'per_page') ? undefined : json['per_page'],
        'sortField': !exists(json, 'sort_field') ? undefined : json['sort_field'],
        'sortOrder': !exists(json, 'sort_order') ? undefined : json['sort_order'],
        'dangerouslyFetchAllMediaOutlets': !exists(json, 'dangerously_fetch_all_media_outlets') ? undefined : json['dangerously_fetch_all_media_outlets'],
    };
}

export function GetPrtimesMediaListsMediaOutletsRequestToJSON(value?: GetPrtimesMediaListsMediaOutletsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_ids': value.mediaListIds,
        'media_type_ids': value.mediaTypeIds,
        'reaches': ((value.reaches as Array<any>).map(MediaReachToJSON)),
        'page': value.page,
        'per_page': value.perPage,
        'sort_field': value.sortField,
        'sort_order': value.sortOrder,
        'dangerously_fetch_all_media_outlets': value.dangerouslyFetchAllMediaOutlets,
    };
}

